import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout";
import Students from "./pages/Students";
import ViewStudnets from "./pages/ViewStudnets";
import CollegeBill from "./pages/CollegeBill";
import CollegePaymentsRecords from "./pages/CollegePaymentsRecords";
import CollegeAccountUpdate from "./pages/CollegeAccountUpdate";
import HostelBillGenerate from "./pages/HostelBillGenerate";
import HostelBillRecords from "./pages/HostelBillRecords";
import HostelAccountUpdated from "./pages/HostelAccountUpdated";
import TuitionBillGenerate from "./pages/TuitionBillGenerate";
import TuitionAccountUpdated from "./pages/TuitionAccountUpdated";
import TuitionBillRecords from "./pages/TuitionBillRecords";
import Profile from "./components/Profile";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Login page (only accessible if not logged in) */}
          <Route path="/" element={<Login />} />

          {/* Protected Routes (with Header & Sidebar) */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/students" element={<Students />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/view-students" element={<ViewStudnets />} />
              {/* college */}
              <Route path="/college-fees-bill" element={<CollegeBill />} />
              <Route path="/college-payment-records" element={<CollegePaymentsRecords />} />
              <Route path="/college-account-update" element={<CollegeAccountUpdate />} />
              {/* hostel  */}
              <Route path="/hostel/generate-bill" element={<HostelBillGenerate />} />
              <Route path="/hostel/payment-records" element={<HostelBillRecords />} />
              <Route path="/hostel/account-update" element={<HostelAccountUpdated />} />
              {/* tuition */}
              <Route path="/tuition/generate-bill" element={<TuitionBillGenerate />} />
              <Route path="/tuition/payment-records" element={<TuitionBillRecords />} />
              <Route path="/tuition/account-update" element={<TuitionAccountUpdated />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
